import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { CpForecastService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-body/control-page-forecast/cp-forecast-service';

@Component({
  selector: 'app-cp-forecast-today',
  templateUrl: './cp-forecast-today.component.html',
  styleUrl: './cp-forecast-today.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CpForecastTodayComponent {

  forecast = inject(CpForecastService).forecast;

  today = computed(() => this.forecast().forecastDays[0]);

  EnumMeasureTypes = EnumMeasureTypes;

}
